import React, { useMemo } from "react";

import pluralize from "pluralize";
import { Icon, Placeholder } from "semantic-ui-react";

import { useInstallUseCaseMutation, useUseCaseTemplates } from ".";

function useOnboardingUseCaseItemProps(useCases) {
  const { installUseCase, loading, selectedUseCase } =
    useInstallUseCaseMutation();

  const { loadingUseCasesTemplates, useCasesTemplates } = useUseCaseTemplates(
    useMemo(() => {
      return useCases.map((useCase) => {
        return useCase.templateName;
      });
    }, [useCases])
  );

  return (useCase) => {
    const template = useCasesTemplates[useCase.templateName] || {};

    return {
      ...useCase,
      tooltip: template.installed
        ? "This use case is already installed in your hub"
        : "",
      installed: template.installed,
      disabled: template.installed || loadingUseCasesTemplates,
      loading:
        (loading && selectedUseCase === useCase.templateName) ||
        loadingUseCasesTemplates,
      action: `Install Use Case: ${useCase.title}`,
      footer: (
        <React.Fragment>
          <Icon
            name="align left"
            color="black"
            style={{ transform: "rotate(90deg)" }}
          />

          {loadingUseCasesTemplates ? (
            <div style={{ flexGrow: 1.5 }}>
              <Placeholder>
                <Placeholder.Paragraph>
                  <Placeholder.Line />
                </Placeholder.Paragraph>
              </Placeholder>
            </div>
          ) : (
            <span
              style={{
                color: "black",
                fontWeight: "bold",
                fontSize: "12px",
              }}
            >
              {`${template.numWorkflows || 0} ${pluralize(
                "Workflow",
                template.numWorkflows || 0
              )}`}
            </span>
          )}
        </React.Fragment>
      ),
      onClick: async () => {
        await installUseCase({ useCaseName: useCase.templateName });
      },
    };
  };
}
export default useOnboardingUseCaseItemProps;
